/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as TransportationDataStoreActions from './transportation-data-store.actions';

import { Transportation } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'TransportationDataStore';

/* State interface */
export interface TransportationState {
  isLoading?: boolean;
  transportation?: Transportation[];
  activeTransportation?: Transportation;
}

/* Initial values */
export const initialState: TransportationState = {
  isLoading: null,
  transportation: null,
  activeTransportation: null,
};

export const reducer = createReducer(
  initialState,
  on(TransportationDataStoreActions.GetTransportation, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    TransportationDataStoreActions.GetTransportationSuccessful,
    (state, action) => ({
      ...state,
      transportation: action.payload.transportation,
      isLoading: false,
    }),
  ),

  on(
    TransportationDataStoreActions.GetTransportationFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(TransportationDataStoreActions.GetTransportationById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    TransportationDataStoreActions.GetTransportationByIdSuccessful,
    (state, action) => ({
      ...state,
      /* TODO: replace item by id from data array */
      isLoading: false,
    }),
  ),

  on(
    TransportationDataStoreActions.GetTransportationByIdFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(
    TransportationDataStoreActions.GetActiveTransportationWithRelationsById,
    (state, action) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(
    TransportationDataStoreActions.GetActiveTransportationByIdWithRelationsSuccessful,
    (state, action) => ({
      ...state,
      activeTransportation: action.payload.activeTransportation,
      isLoading: false,
    }),
  ),

  on(
    TransportationDataStoreActions.GetActiveTransportationByIdWithRelationsFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(TransportationDataStoreActions.CreateTransportation, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    TransportationDataStoreActions.CreateTransportationSuccessful,
    (state, action) => ({
      ...state,
      transportation: [
        ...(state.transportation ?? []),
        action.payload.transportation,
      ],
      isLoading: false,
    }),
  ),

  on(
    TransportationDataStoreActions.CreateTransportationFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(TransportationDataStoreActions.UpdateTransportation, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    TransportationDataStoreActions.UpdateTransportationSuccessful,
    (state, action) => ({
      ...state,
      transportation: updateEntityInArray<Transportation>(
        action.payload.id,
        action.payload.data,
        state.transportation ?? [],
      ),
      isLoading: false,
    }),
  ),

  on(
    TransportationDataStoreActions.UpdateTransportationFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(TransportationDataStoreActions.DeleteTransportation, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    TransportationDataStoreActions.DeleteTransportationSuccessful,
    (state, action) => ({
      ...state,
      transportation:
        state.transportation?.filter((item) => action.payload.id !== item.id) ??
        [],
      isLoading: false,
    }),
  ),

  on(
    TransportationDataStoreActions.DeleteTransportationFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(TransportationDataStoreActions.ResetState, () => initialState),
);
